// One page of the Compliance table in a single request: the people the employee filter
// finds, and their hours and inspections over the other two filters' dates. ServiceInspection's
// ComplianceListExecutor answers with the EmployeeMap, UserMap, RoleMap, TimesheetMap,
// VehicleInspectionMap, VehicleMap and CategoryMap under their usual model names, and the
// people's count under ComplianceOperations.List.CountKey.
export default class ComplianceOperations {

  constructor(eventsDomain) {
    this.eventsDomain = eventsDomain;
    this.domain = this.eventsDomain.domain;
  }

  contains(name) {
    if (name) {
      //
    }
    return false;
  }

  list(employeeFilter, timesheetFilter, inspectionFilter) {
    var event = new ComplianceOperations.List.Operation(employeeFilter, timesheetFilter, inspectionFilter);
    return this.eventsDomain.initRequest(event);
  }

  // One page of the Vehicles or Equipment tab: the vehicles the vehicle filter finds and their
  // inspections, as the vehicle or as a trailer, over the inspection filter's dates.
  // ServiceInspection's ComplianceVehicleListQueryExecutor answers with the VehicleMap (no
  // embedded photos; the ImageMap carries their urls), VehicleInspectionMap, EmployeeMap and
  // UserMap, the vehicles' count under List.CountKey, and the page's vehicle ids under
  // VehicleList.IdsKey - the VehicleMap also holds the trucks that pulled a page's trailers.
  vehicleList(vehicleFilter, inspectionFilter) {
    var event = new ComplianceOperations.VehicleList.Operation(vehicleFilter, inspectionFilter);
    return this.eventsDomain.initRequest(event);
  }

  static VehicleList = {
    Names: {
      Operation: 'ComplianceVehicleListQueryOperation',
      Notification: 'ComplianceVehicleListNotification',
    },

    IdsKey: 'vehicleIds',

    Operation: function (vehicleFilter, inspectionFilter) {
      return {
        handler: ComplianceOperations.VehicleList.Names.Operation,
        eventName: ComplianceOperations.VehicleList.Names.Operation,
        vehicleFilter: vehicleFilter.data,
        inspectionFilter: inspectionFilter.data,
      };
    },
  }

  static List = {
    Names: {
      Operation: 'ComplianceListQueryOperation',
      Notification: 'ComplianceListNotification',
    },

    CountKey: 'count',

    Operation: function (employeeFilter, timesheetFilter, inspectionFilter) {
      var event = {
        handler: ComplianceOperations.List.Names.Operation,
        eventName: ComplianceOperations.List.Names.Operation,
        employeeFilter: employeeFilter.data,
        timesheetFilter: timesheetFilter.data,
        inspectionFilter: inspectionFilter.data,
      }
      return event;
    },
  }
}
